import { Deserializable } from '../protocols/deserializable';
import { TaxFormTypeIdEnum } from './tax-form-type-id.enum';

export class TaxFormType implements Deserializable {
  public id!: TaxFormTypeIdEnum;
  public name!: string;
  public stateId!: number | null;
  public stateCode!: string | null;
  public stateName!: string | null;
  public countryId!: number;
  public countryCode!: string;
  public countryName!: string;

  onDeserialize() {}
}
